import * as React from "react";
import { faCircleExclamationCheck } from "@fortawesome/pro-regular-svg-icons/faCircleExclamationCheck";
import { IconButton, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PointTypedButton: React.FC<{ active: boolean; readonly?: boolean, tooltip: string; onClick: () => void; }> = ({ active, readonly, tooltip, onClick }) => {

    const theme = useTheme();

    return (
        <IconButton
            title={tooltip}
            onClick={onClick}
            disabled={readonly}>
            <FontAwesomeIcon
                icon={faCircleExclamationCheck}
                color={active ? theme.palette.highlight.main : theme.palette.muted.main}
                fixedWidth
            />
        </IconButton>
    );
};
